import { defineMessages } from 'react-intl.macro';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import './Menu.scss';

import { SvgHome, SvgHelp, Icon } from '@tmapy/style-guide';

import { VERSION } from '../../constants';
import { UserInfo } from './UserInfo';
import { Link } from '../../link';
import { RouteId } from '../../routes';

const msg = defineMessages({
  copyright: {
    id: 'app.copyright',
    defaultMessage: '{version} © {tmapy}',
  },
  tmapy: {
    id: 'app.copyright.tmapy',
    defaultMessage: 'T-MAPY spol. s r. o.',
  },
});

interface MenuProps {
  title: string;
  subtitle?: string;
  userDocumentation?: string;
  homeLink?: string;
  appLink: RouteId;
  children: React.ReactNode;
}

export const Menu: React.FC<MenuProps> = ({
  title,
  subtitle,
  userDocumentation,
  homeLink,
  appLink,
  children,
}) => {
  return (
    <header className='dmx-menu'>
      <h1 className='dmx-menu--appTitle'>
        <Link to={appLink}>
          {subtitle && <span className='sg-u-type-sideNavHeading-inverse'>{subtitle}</span>}
          <span>{title}</span>
        </Link>
      </h1>
      <section>
        <UserInfo />
      </section>
      <nav className='dmx-menu--nav'>{children}</nav>
      <section className='sg-a-d-f sg-a-cg-1'>
        {homeLink && (
          <a className='dmx-menu--homeLink' href={homeLink} rel='noopener noreferrer'>
            <Icon size="med" element={<SvgHome />} />
          </a>
        )}
        {userDocumentation && (
          <a
            className='dmx-menu--homeLink'
            href={userDocumentation}
            target='_blank'
            rel='noopener noreferrer'
          >
            <Icon size="med" element={<SvgHelp />} />
          </a>
        )}
      </section>
      <p className='dmx-menu--copyright sg-a-mt-2'>
        <FormattedMessage
          {...msg.copyright}
          values={{
            version: VERSION,
            tmapy: (
              <a
                key={msg.tmapy.id}
                href='https://www.tmapy.cz'
                target='_blank'
                rel='noopener noreferrer'
              >
                <FormattedMessage {...msg.tmapy} />
              </a>
            ),
          }}
        />
      </p>
    </header>
  );
};
